// The list of sets (code -> name, release date) is static for a session.
// Fetch it ONCE and share it: before this, every card tile fetched the
// whole list for itself, and a dependency bug made each tile do so in a
// loop for as long as it was on screen.

let setsPromise = null;

/** Resolves to the full array from /api/sets, fetched at most once. */
export function getSets() {
    if (!setsPromise) {
        setsPromise = fetch('/api/sets')
            .then(r => (r.ok ? r.json() : []))
            .then(list => (Array.isArray(list) ? list : []))
            .catch(() => {
                setsPromise = null; // let a later call retry after a network blip
                return [];
            });
    }
    return setsPromise;
}

/** Resolves to the set's display name, or the code itself when unknown. */
export async function getSetName(setCode) {
    if (!setCode) return '';
    const sets = await getSets();
    return sets.find(s => s.setCode === setCode)?.setName || setCode;
}

/** Test hook: forget the cached list. */
export function _resetSetsCache() {
    setsPromise = null;
}
